import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import i18n from "i18next";
import Cookies from "js-cookie";
import logo from "../img/logo.svg";
import logo_mob from "../img/logo.svg";
import MobileMenu from "./MobileMenu";
import { LinkContext } from "../LinkProvider";
import { useContext } from "react";

function Header() {

    const { link } = useContext(LinkContext);

    const { t } = useTranslation();
    const location = useLocation();

    const languages = [
        { value: 'en', label: 'EN' },
        { value: 'ru', label: 'RU' },
        { value: 'es', label: 'ES' },
        { value: 'it', label: 'IT' },
        { value: 'de', label: 'DE' },
    ]

    const storedLang = Cookies.get("i18next");
    const [currentLang, setCurrentLang] = useState(storedLang || 'en');

    useEffect(() => {
        if (storedLang && storedLang !== currentLang) {
            setCurrentLang(storedLang);
            i18n.changeLanguage(storedLang);
        }
        // eslint-disable-next-line
        document.body.setAttribute('dir', storedLang === 'ar' ? 'rtl' : 'ltr');
    }, [storedLang]);
    

    const handleChangeLang = (selectedLang) => {
        setCurrentLang(selectedLang.value);
        i18n.changeLanguage(selectedLang.value);
        Cookies.set("i18next", selectedLang.value);
    };

    return (
        <div className="fixed top-0 left-0 w-full bg-white z-[1000]">
            <div className="hidden max-w-[1220px] h-[60px] justify-between mx-auto xl:flex items-center">
                <div className="flex items-center gap-[20px]">
                    <Link to="/"><img src={logo} alt="" className="w-[120px]"/></Link>
                    <Link to="/trading"><p className={`text-[16px] roboto transition-all ${location.pathname === '/trading' ? 'font-[500]' : 'text-[#000000B2]'}`}>{t('header.1')}</p></Link>
                    <Link to="/sponsor"><p className={`text-[16px] roboto transition-all ${location.pathname === '/sponsor' ? 'font-[500]' : 'text-[#000000B2]'}`}>{t('header.2')}</p></Link>
                    <Link to="/account"><p className={`text-[16px] roboto transition-all ${location.pathname === '/account' ? 'font-[500]' : 'text-[#000000B2]'}`}>{t('header.3')}</p></Link>
                    <Link to="/partner"><p className={`text-[16px] roboto transition-all ${location.pathname === '/partner' ? 'font-[500]' : 'text-[#000000B2]'}`}>{t('header.4')}</p></Link>
                    <Link to="/aboutus"><p className={`text-[16px] roboto transition-all ${location.pathname === '/aboutus' ? 'font-[500]' : 'text-[#000000B2]'}`}>{t('header.5')}</p></Link>
                </div>
                <div className="flex items-center gap-[20px]">
                    <Dropdown
                        options={languages}
                        placeholder="EN"
                        onChange={handleChangeLang}
                        value={languages.find(lang => lang.value === currentLang)}
                    />
                    <a href={link}>
                        <div className="cursor-pointer border border-[#131313] hover:py-[5px] transition-all py-[8px] px-[20px] rounded-[60px]">
                            <p className="roboto text-[#131313] text-[16px]">{t('header.button')}</p>
                        </div>
                    </a>
                </div> 
            </div>
            <div className="xl:hidden flex mx-[20px] items-center justify-between h-[60px]">
                <Link to="/"><img src={logo_mob} alt="" className="w-[40px]"/></Link>
                <Dropdown
                    options={languages}
                    placeholder="EN"
                    onChange={handleChangeLang}
                    value={languages.find(lang => lang.value === currentLang)}
                    className="ml-auto mr-[20px]"
                />
                <MobileMenu/>
            </div>
        </div>
    );
}

export default Header;
